import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { MatrixRain } from "@/components/MatrixRain";
import { Logo } from "@/components/Logo";
import { NeonButton } from "@/components/Holo";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const Field = ({ label, ...rest }) => (
  <label className="block">
    <span className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-white/50">{label}</span>
    <input {...rest} className="mt-2 w-full bg-black/30 border-b border-white/20 focus:border-neon-pink focus:outline-none px-1 py-2 text-white font-mono-tech text-sm transition-colors" />
  </label>
);

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Identity created. Welcome, Creator.");
      navigate("/app");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-screen bg-[#050505] grain flex items-center justify-center px-5 overflow-hidden">
      <div className="absolute inset-0"><MatrixRain opacity={0.18} color="#ff007f" /></div>
      <div className="absolute inset-0 cyber-grid opacity-30" />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="relative z-10 w-full max-w-md glass clip-corner border border-white/10 p-8"
        style={{ borderTop: "1px solid rgba(255,0,127,0.6)" }} data-testid="register-card">
        <Link to="/"><Logo variant="neon" className="h-10 mb-8" /></Link>
        <h1 className="font-display font-bold text-2xl">Create Your Identity</h1>
        <p className="font-mono-tech text-white/40 text-xs mt-1">50 free credits · Credit Shield included</p>
        <form onSubmit={submit} className="mt-8 space-y-6">
          <Field label="Creator Name" required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" placeholder="Neo Anderson" />
          <Field label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" placeholder="creator@futra.ai" />
          <Field label="Password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" placeholder="••••••••" />
          <NeonButton accent="pink" type="submit" className="w-full" disabled={loading} data-testid="register-submit">
            {loading ? "Initializing..." : "Generate Neural Profile"}
          </NeonButton>
        </form>
        <p className="mt-6 font-mono-tech text-xs text-white/40">
          Already registered? <Link to="/login" className="text-neon-turquoise hover:underline" data-testid="to-login">Access Center</Link>
        </p>
      </motion.div>
    </div>
  );
}
